// Copyright (c) 2025 Comsearch, Inc., All rights reserved

export const BAND = 42

const is13GhzBand = (band) => {
  return band == BAND
}

export default is13GhzBand